import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { navigateTo, UpdateUserForm, useGetViewer } from '@amber-ui/core';

/**
 * Route controller for /user/account.
 *
 * Follows the Route-as-Controller pattern: this file owns the URL binding,
 * fetches the viewer, and wires navigation callbacks. The view logic lives
 * in UpdateUserForm (packages/core) which has zero routing awareness.
 */
function UserAccountRoute() {
  const { viewer } = useGetViewer();

  const onSubmitSuccess = useCallback(() => {
    navigateTo('/grain_bin/dashboard');
  }, []);

  const goPasswordForm = useCallback(() => {
    navigateTo('/user/password');
  }, []);

  if (!viewer) return null;

  return (
    <UpdateUserForm
      user={viewer.user}
      onSubmitSuccess={onSubmitSuccess}
      onClickPassword={goPasswordForm}
    />
  );
}

export const Route = createFileRoute('/_auth/user/account')({
  component: UserAccountRoute,
});
